import { ApiError, api } from '../lib/api.js';
import { clear, el } from '../lib/dom.js';

export function renderLogin(root: HTMLElement, onLogin: () => void): void {
  clear(root);
  document.body.classList.remove('hat-navbar');

  const wrap = el('div', { class: 'login-wrap' });
  const card = el('div', { class: 'card login-card' });
  card.append(
    el('div', { class: 'logo' }, 'Wertermittlung'),
    el(
      'div',
      { class: 'sub' },
      'Landesverband Schleswig-Holstein der Gartenfreunde · Anmeldung für Vereine und Kommissionen',
    ),
  );

  const error = el('div', { class: 'form-error', role: 'alert' });
  error.style.display = 'none';

  const form = el('form');
  const emailField = el('div', { class: 'field' });
  emailField.append(el('label', { for: 'login-email' }, 'E-Mail-Adresse'));
  const email = el('input', {
    id: 'login-email',
    type: 'email',
    autocomplete: 'username',
    required: 'required',
  });
  emailField.append(email);

  const pwField = el('div', { class: 'field' });
  pwField.style.marginTop = '12px';
  pwField.append(el('label', { for: 'login-pw' }, 'Passwort'));
  const pw = el('input', {
    id: 'login-pw',
    type: 'password',
    autocomplete: 'current-password',
    required: 'required',
  });
  pwField.append(pw);

  const submit = el('button', { class: 'btn btn-primary', type: 'submit' }, 'Anmelden');
  submit.style.width = '100%';
  submit.style.marginTop = '16px';

  form.append(error, emailField, pwField, submit);
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    error.style.display = 'none';
    submit.disabled = true;
    api
      .login(email.value, pw.value)
      .then(() => onLogin())
      .catch((err: unknown) => {
        error.textContent =
          err instanceof ApiError && err.status === 429
            ? 'Zu viele Versuche. Bitte eine Minute warten.'
            : err instanceof ApiError
              ? err.message
              : 'Keine Verbindung zum Server.';
        error.style.display = 'block';
      })
      .finally(() => {
        submit.disabled = false;
      });
  });

  card.append(form);
  wrap.append(card);
  root.append(wrap);
  email.focus();
}
